// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sets Accessibility (de:BFR/BAIM) on each `ScheduledStopPoint::accessibilityBoardingAlighting` for better handicap support using vehicles. This is especially relevant on first (boarding) and last (alighting) of each `PTRideLeg::serviceJourney::stopPoints` (implicitely affects transfers).<br>If 'NONE' or non `PTRideLeg's` irrelevant and never given.<br>This filter **needs special Grants for a clientId**, if you observe **403 FORRBIDDEN, please ajdust.** Set NONE instead!<br>x-extensible-enum:  see enum values.<br>`ServiceJourney::notices` will get an entry of `type=INFO, key=RN` if available, its `Notice::value` is relevant for Postauto AG (PAG) operations-reference.
 * @export
 */
export const AccessibilityEnum = {
    All: 'ALL',
    AllTransferCriticalHint: 'ALL_TRANSFER_CRITICAL_HINT',
    BoardingAlightingSelf: 'BOARDING_ALIGHTING_SELF',
    BoardingAlightingByCrew: 'BOARDING_ALIGHTING_BY_CREW',
    BoardingAlightingByNotification: 'BOARDING_ALIGHTING_BY_NOTIFICATION',
    BoardingAlightingShuttleTransport: 'BOARDING_ALIGHTING_SHUTTLE_TRANSPORT',
    None: 'NONE'
} as const;
export type AccessibilityEnum = typeof AccessibilityEnum[keyof typeof AccessibilityEnum];


export function instanceOfAccessibilityEnum(value: any): boolean {
    for (const key in AccessibilityEnum) {
        if (Object.prototype.hasOwnProperty.call(AccessibilityEnum, key)) {
            if (AccessibilityEnum[key as keyof typeof AccessibilityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccessibilityEnumFromJSON(json: any): AccessibilityEnum {
    return AccessibilityEnumFromJSONTyped(json, false);
}

export function AccessibilityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessibilityEnum {
    return json as AccessibilityEnum;
}

export function AccessibilityEnumToJSON(value?: AccessibilityEnum | null): any {
    return value as any;
}

export function AccessibilityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): AccessibilityEnum {
    return value as AccessibilityEnum;
}

